import { Row, Col, Button } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import "./Contact.css";
import ContactBg from "../../assets/contact-bg.svg";
import HalfCircle from "../../assets/half-circle.svg";
import { useForm } from "react-hook-form";

import axios from "../../network/api";
import { useState, useEffect } from "react";
import { baseUrl } from "../../network/Constants";

function Contact() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [banners, setBanners] = useState([]);

  const onSubmit = (data) => {
    axios
      .post(baseUrl + "/app/ContactUs/", data)
      .then(async (response) => {
        // setLoading(false);
        // setBanners(response.data);
        console.log("contactResp: " + response.data.message);
        if (response.data.message === "Email has been sent") {
        }
      })
      .catch((error) => {
        console.log(error);
        // setLoading(true);
      });
  };

  return (
    <section className="contact pt-5" id="contact">
      <Container fluid className="p-0 contact-bg-container">
        <img
          src={ContactBg}
          alt="Contact Image"
          className="contact-bg img-fluid"
        />

        <div className="contact-content">
          <div className="contact-title">Contact Us</div>
          <Container>
            <Row className="contact-row">
              <Col lg={6} className="left-col pt-3">
                <img
                  src={HalfCircle}
                  alt="Contact Image"
                  className="img-fluid contact-left-img"
                />
                <div className="contact-text-container">
                  <div className="contact-left-title">Speak with Us</div>

                  <div className="contact-left-content">
                    Stay connected with us! For any inquiries, collaborations,
                    or to share your alumni story, feel free to reach out. We’d
                    love to hear from you!
                  </div>
                </div>
              </Col>
              <Col
                lg={6}
                className="right-col pt-3 d-flex justify-content-center"
              >
                <form
                  onSubmit={handleSubmit(onSubmit)}
                  className="contact-form"
                >
                  {/* Name */}
                  <input
                    {...register("name", { required: "Name is required" })}
                    placeholder="Name"
                  />
                  {errors.name && (
                    <p className="error">{errors.name.message}</p>
                  )}

                  {/* Email */}
                  <input
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value:
                          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        message: "Invalid email address",
                      },
                    })}
                    placeholder="Email"
                  />
                  {errors.email && (
                    <p className="error">{errors.email.message}</p>
                  )}

                  {/* Phone */}
                  <input
                    {...register("phone", {
                      required: "Phone number is required",
                      pattern: {
                        value: /^[0-9]{10}$/,
                        message: "Enter a valid 10-digit phone number",
                      },
                    })}
                    placeholder="Phone"
                  />
                  {errors.phone && (
                    <p className="error">{errors.phone.message}</p>
                  )}

                  {/* Message */}
                  <textarea
                    rows="5"
                    {...register("message", {
                      required: "Message is required",
                    })}
                    placeholder="Message"
                  />
                  {errors.message && (
                    <p className="error">{errors.message.message}</p>
                  )}

                  {/* Submit Button */}
                  <Button className="enquire-now-btn mt-5" type="submit">
                    {/* <img src={ViewMoreIcon} /> */}
                  </Button>
                </form>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>
    </section>
  );
}

export default Contact;
